<div class="notify-template-preview">
    <div class="notification">
        {{ 'notifyTemplates.previewEmailNotification'|translate }}
    </div>
    <div class="cover-image">
        <a href="#" (click)="openCustomerWebsite($event, template?.CustomerWebsite)">
            @if (template?.CoverBannerS3Url) {
                <img [attr.src]="((template?.CoverBannerS3Url | decode | sanitize) || '') | safe:'url'"
                     alt="Cover Image">
            }
        </a>
    </div>
    <div class="tag-line">{{ 'notifyTemplates.thumbnailTagLine'|translate }}</div>
    <h5 class="title">{{ 'notifyTemplates.thumbnailTitle'|translate }}</h5>
    <div class="banner-wrapper">
        <div class="banner-image" *ngIf="template?.BannerS3Url">
            <img *ngIf="template?.BannerS3Url"
                 [attr.src]="(template?.BannerS3Url | decode | sanitize) | safe:'url'"
                 alt="Banner">
            <span *ngIf="!template?.BannerS3Url">150 x 150</span>
        </div>
        <div class="banner-description">
            {{ 'notifyTemplates.shipmentContent'|translate }}
        </div>
    </div>
    <div class="divider"></div>
    <div class="content-wrapper">
        <div class="content-item">
            <div class="key-value">
                <div class="key">{{ 'shipFrom'|translate }}:</div>
                <div class="value"></div>
            </div>
            <div class="key-value">
                <div class="key">{{ 'ShippingDestination'|translate }}:</div>
                <div class="value">{{ 'notifyTemplates.customerDestination'|translate }}</div>
            </div>
        </div>
        <div class="content-item">
            <div class="key-value-inline">
                <div class="key">{{ 'notifyTemplates.carrierName'|translate }}:</div>
                <div class="value">{{ 'notifyTemplates.carrierNameShow'|translate }}</div>
            </div>
            <div class="key-value-inline">
                <div class="key">{{ 'notifyTemplates.parcelProTracking'|translate }} #:</div>
                <div class="value">
                    <a href="javascript:;">{{ 'notifyTemplates.trackingHere'|translate }}</a>
                </div>
            </div>
            <button mat-raised-button color="primary">{{ 'notifyTemplates.trackShipment'|translate }}</button>
            <div class="remark">
                {{ 'notifyTemplates.trackingInformationAvailability'|translate }}
            </div>
        </div>
    </div>

    <div class="showcase" *ngIf="template?.shouldDisplayShowcaseImages && showcaseItems.length">
        <div class="divider"></div>

        <h6 class="title">{{ 'notifyTemplates.shipperShowcase'|translate }}</h6>
        <div class="showcase-items">
            <div class="showcase-item" *ngFor="let item of showcaseItems">
                <img src="{{ item | decode | sanitize }}" alt="Showcase Item">
            </div>
        </div>
    </div>

    <div class="messages">
        <p>
            {{ 'notifyTemplates.notifyTemplatePreviewMessages.message1'|translate }}
        </p>
        <p>
            {{ 'notifyTemplates.notifyTemplatePreviewMessages.message2'|translate }}
        </p>
        <p [innerHtml]="'notifyTemplates.notifyTemplatePreviewMessages.message3'|translate:{ termsOfUseURL: termsOfUseURL, parcelProHelpURL: parcelProHelpURL }">
        </p>
        <p>
            &copy; {{ today | date:'yyyy' }} {{ copyrightMessage | translate}}
        </p>
        <div *ngIf="isEUUser">
            <p [innerHtml]="this.message5">
            </p>
            <p [innerHtml]="this.message6">
            </p>
            <p [innerHtml]="this?.message7">
            </p>
            <p [innerHtml]="this?.message8">
            </p>
        </div>
    </div>

    <div class="template-footer">
        <span>
            {{ 'notifyTemplates.templateFooter1'|translate }}
        </span>
        <span>
            {{ 'notifyTemplates.templateFooter2'|translate }} {{ today | date:'yyyy' }}
            <a href="http://www.parcelpro.com" target="_blank">www.parcelpro.com</a>
        </span>
    </div>
</div>
